/**
 * 重置密码页面 API 接口
 * 包含：重置密码
 */
import { csHttp } from '@/utils/http';
import { API_BASE_URL } from '@/config/env';

// ==================== 接口常量 ====================

const CS_RESET_PASSWORD_API_URL = `${API_BASE_URL}/ai/cs-api/v1/staff/resetPassword`;

// ==================== 类型定义 ====================

export interface ResetPasswordParams {
  password: string;
}

export interface ResetPasswordData {
  success: boolean;
}

// ==================== 重置密码接口 ====================

/** 重置密码 */
export function resetPasswordApi(data: ResetPasswordParams) {
  return csHttp.post<ResetPasswordData>(CS_RESET_PASSWORD_API_URL, data);
}
